import { usePromiseTracker } from 'react-promise-tracker';

/**
 * Creates a React Promise Tracker custom hook that exposes the `promiseInProgress` boolean
 * @param param tag - string promiseTracker tag
 * @param delay number - optional parameter for delay promise in progress. Default value is 0
 * @returns boolean -  promise tracker boolean hook
 */
const PromiseByTag = ({ tag, delay = 0 }: { tag: string; delay: number }) => {
  const { promiseInProgress } = usePromiseTracker({ area: tag, delay: delay });

  return promiseInProgress;
};

/**
 * Provided an array of tags, returns an array of booleans to follow promises in progress
 * @param tags string[] - promiseTracker tags you wish to observe
 * @param delay number - optional parameter for delay promise in progress. Default value is 0
 * @returns boolean[] - all promised hooks associated to the tags
 */
const createPromisesFromTags = (
  tags: string[],
  delay: number = 0,
): boolean[] => {
  if (tags !== undefined && tags.length > 0) {
    // iterate over each tags and get add to a list of promise trackers
    let promisesInProgress = tags.map((t) => {
      return PromiseByTag({ tag: t, delay: delay });
    });

    return promisesInProgress;
  }

  return [];
};

/**
 * Provided an array of tags, returns a boolean if any are considered still in progress of a promise
 * @param tags string[] - promiseTracker tags you wish to observe
 * @param delay number - optional parameter for delay promise in progress. Default value is 0
 * @returns boolean - if one or more tags is still in progress
 */
const anyPromiseTrackerTagsInProgress = (
  tags: string[],
  delay: number = 0,
): boolean => {
  return createPromisesFromTags(tags, delay).some((p) => p === true);
};

export { createPromisesFromTags, anyPromiseTrackerTagsInProgress };
